import { Chip, ClickAwayListener, Paper, Popper } from '@mui/material';
import moment from 'moment';
import { Dispatch, SetStateAction, useState } from 'react';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';

interface DateRangeType {
  from: Date | undefined;
  to: Date | undefined;
}

interface Props {
  range: {
    from: Date | undefined;
    to: Date | undefined;
  };
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  anchorEl: HTMLElement | null;
  setAnchorEl: Dispatch<SetStateAction<HTMLElement | null>>;
  selectedChip: string;
  setSelectedChip: Dispatch<SetStateAction<string>>;
  month: Date;
  setMonth: Dispatch<SetStateAction<Date>>;
  setRange: Dispatch<SetStateAction<DateRangeType>>;
}
const DateRange = ({
  range,
  anchorEl,
  month,
  open,
  selectedChip,
  setMonth,
  setOpen,
  setRange,
  setSelectedChip,
  setAnchorEl,
}: Props) => {
  const handleSelect = (selectedRange: any) => {
    if (selectedRange === undefined) {
      setRange({ from: undefined, to: undefined });
    } else {
      setRange(selectedRange);
    }
  };
  const handleMonthChange = (newMonth: any) => {
    setMonth(newMonth);
  };

  const handleChipClick = (value: any) => {
    if (value === selectedChip) {
      setSelectedChip('');
      setRange({ from: undefined, to: undefined });
      setMonth(moment().toDate());
      return;
    }
    setSelectedChip(value);

    let newRange = { from: moment().toDate(), to: moment().toDate() };
    const today = moment();

    if (value === 'lastMonth') {
      newRange = {
        from: moment().subtract(1, 'months').startOf('month').toDate(),
        to: moment().subtract(1, 'months').endOf('month').toDate(),
      };
    } else if (value === 'lastWeek') {
      newRange = {
        from: moment().subtract(7, 'days').startOf('day').toDate(),
        to: today.toDate(),
      };
    } else if (value === 'lastYear') {
      newRange = {
        from: moment().subtract(1, 'years').startOf('year').toDate(),
        to: moment().subtract(1, 'years').endOf('year').toDate(),
      };
    }
    setRange(newRange);
    setMonth(newRange.from);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="bottom-start"
      disablePortal
      style={{
        position: 'relative',
        zIndex: 1,
      }}
    >
      <ClickAwayListener onClickAway={handleClose}>
        <Paper elevation={3} style={{ position: 'relative', zIndex: 1 }}>
          <div
            style={{
              padding: 8,
              borderRadius: 10,
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-around',
                padding: '8px',
              }}
            >
              <Chip
                label="Last Week"
                variant={selectedChip === 'lastWeek' ? 'filled' : 'outlined'}
                onClick={() => handleChipClick('lastWeek')}
              />
              <Chip
                label="Last Month"
                variant={selectedChip === 'lastMonth' ? 'filled' : 'outlined'}
                onClick={() => handleChipClick('lastMonth')}
              />
              <Chip
                label="Last Year"
                variant={selectedChip === 'lastYear' ? 'filled' : 'outlined'}
                onClick={() => handleChipClick('lastYear')}
              />
            </div>

            <DayPicker
              className="react-day-picker"
              mode="range"
              selected={range}
              onSelect={handleSelect}
              month={month}
              onMonthChange={handleMonthChange}
            />
          </div>
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
};

export default DateRange;
